import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { cn } from "@omni/utils/styles";

import { PromotionItems } from "@/components/Cart/ShoppingCart/promotionItems/promotionItems.component";
import { CartModel } from "@/redux/modules/api/data/cart/@types/cart.model";

import TotalsBlockComponent from "../totalsBlock/totalsBlock.component";

type TotalsOverviewProps = { shoppingCart?: CartModel | null };

const TotalsOverview = ({ shoppingCart }: TotalsOverviewProps) => {
    const deliveryProducts = shoppingCart?.items.filter(
        (i) =>
            i.deliveryType === DeliveryType.HomeDelivery &&
            !i.isAdditionalService
    );

    const deliveryCost = deliveryProducts?.length
        ? (shoppingCart?.deliveryCost ?? 0)
        : undefined;
    return (
        <div>
            <section className={cn("tw:px-4")}>
                {
                    <TotalsBlockComponent
                        deliveryCost={deliveryCost}
                        discountTotal={shoppingCart?.discountTotal}
                        giftCardTotal={shoppingCart?.giftCardTotal}
                        serviceTotal={shoppingCart?.serviceTotal}
                        subTotal={shoppingCart?.subTotal}
                        totalPrice={shoppingCart?.totalPrice}
                    />
                }
            </section>
            <section className={cn("tw:px-4")}>
                <PromotionItems promotions={shoppingCart?.promotions} />
            </section>
        </div>
    );
};

export { TotalsOverview };
